/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { checkArray } from '../../../Components/helper';
import { useProductInformationState } from './Provider/index';
import * as action from '../store/DevelopmentOrder.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { NewCheckbox } from '../../../Components/PIM/common/NewCheckbox';

function ProductGroupModal({ item, show, handleClose, handleOpenProductGroup, groupId }) {
  const reducer = useSelector((reducerState) => reducerState);
  const { ProductListData, Measuremets } = reducer;
  const { productGroups } = ProductListData;
  const { editedDevOrderData } = Measuremets;
  const dispatch = useDispatch();
  const [state, setState] = useState({
    selectedGroups: [],
    productGroupsOption: [],
    productActiveGroup: [],
    selectedIndex: [],
    isAllChecked: false,
  });
  const { selectedGroups, productGroupsOption, productActiveGroup, selectedIndex, isAllChecked } = state;
  const { callGetDevorderListApi } = useProductInformationState();
  useEffect(() => {
    if (checkArray(productGroups)) {
      setState((prevData) => ({
        ...prevData,
        productGroupsOption: productGroups.map((ele) => {
          return { label: ele.name, value: ele._id };
        }),
      }));
    }
  }, [productGroups]);

  useEffect(() => {
    if (!isEmpty(editedDevOrderData)) {
      setState((prevData) => ({
        ...prevData,
        productActiveGroup: editedDevOrderData?.prodGroups?.map((ele) => {
          return { label: ele.name, value: ele._id };
        }),
        selectedGroups: editedDevOrderData?.prodGroups.map((val) => val._id),
      }));
    }
  }, [editedDevOrderData]);

  useEffect(() => {
    dispatch(action.getEditedProductDetail(item?._id));
  }, []);

  const { t } = useTranslation('common');

  const handleGroupAdd = (items) => {
    let updatedState = {};

    if (isAllChecked) {
      updatedState = {
        ...updatedState,
        selectedIndex: [...selectedIndex, items.length - 1],
      };
    }

    if (isEmpty(items)) {
      updatedState = {
        ...updatedState,
        selectedIndex: [],
        isAllChecked: false,
      };
    }

    updatedState = {
      ...updatedState,
      selectedGroups: items.map((val) => val.value),
      productActiveGroup: items,
    };

    setState((prevData) => ({
      ...prevData,
      ...updatedState,
    }));
  };

  /**
   * Persists the modal's current selection as the product's complete group membership.
   * An empty selection is a valid submission: it removes the product from every group.
   */
  const handleProductToGroup = async () => {
    const objData = {
      prodId: item._id,
      productGroupIds: selectedGroups || [],
    };
    const res = await dispatch(action.addProductToGroup(objData, t));
    if (res?.code === 200) {
      handleClose();
      setState((prevData) => ({
        ...prevData,
        selectedGroups: [],
      }));
      await callGetDevorderListApi({
        archived: false,
        count: 0,
        groupId,
        searchText: '',
      });
    }
  };

  const handleDeleteGoup = (index) => {
    const copyState = productActiveGroup;
    const copyStateIds = selectedGroups;
    copyState.splice(index, 1);
    copyStateIds.splice(index, 1);

    setState((prevData) => ({
      ...prevData,
      selectedGroups: copyStateIds,
      productActiveGroup: copyState,
    }));
  };

  const handleDeleteProductGroup = () => {
    const copyState = productActiveGroup;
    const copyStateIds = selectedGroups;
    setState((prevData) => ({
      ...prevData,
      selectedGroups: copyStateIds.filter((ele, index) => {
        return selectedIndex.indexOf(index) === -1;
      }),
      productActiveGroup: copyState.filter((ele, index) => {
        return selectedIndex.indexOf(index) === -1;
      }),
    }));
  };

  const handleCheck = (e, ind) => {
    const isChecked = e.target.checked;
    const copyState = isChecked ? [...selectedIndex, ind] : selectedIndex.filter((index) => index !== ind);

    setState((prevData) => ({
      ...prevData,
      selectedIndex: copyState,
      isAllChecked: copyState.length === productActiveGroup.length,
    }));
  };

  const handleAllChecked = (isChecked) => {
    if (checkArray(productActiveGroup)) {
      let cloneSelectedIndex = selectedIndex;
      if (isChecked) {
        cloneSelectedIndex = productActiveGroup.map((vl, ins) => ins);
      } else {
        cloneSelectedIndex = [];
      }
      setState((prev) => ({ ...prev, isAllChecked: isChecked, selectedIndex: cloneSelectedIndex }));
    }
  };

  return (
    <Modal className="common-custom-modal modal-medium" show={show} onHide={handleClose}>
      <Modal.Header className="align-items-center">
        <Modal.Title>{t('FILTER.PRODUCT_GROUP')}</Modal.Title>
        <span onClick={handleClose} className="icon-close cursor-pointer ml-auto" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          <div className="d-flex add-product-group-modal">
            <div className="flex-fill max-width-btn ">
              <MultiSelect
                name="group"
                options={productGroupsOption}
                className="product-custom-multiselect common-new-multiselect w-100"
                value={productGroupsOption.filter((val) => checkArray(productGroupsOption) && selectedGroups.includes(val.value))}
                labelledBy={t('FILTER.PRODUCT_GROUP')}
                onChange={(selected) => handleGroupAdd(selected)}
              />
            </div>
            <CustomTooltip tooltipText={t('COMMON_LABEL.ADD')}>
              <button type="button" onClick={() => handleOpenProductGroup()} aria-label={t('COMMON_LABEL.ADD')} className="btn btn-outline sm ml-16 mr-16">
                <span className="icon-Add-bold" />
              </button>
            </CustomTooltip>

            <CustomTooltip tooltipText={t('subMenu.DELETE')}>
              <button type="button" onClick={() => handleDeleteProductGroup()} aria-label={t('subMenu.DELETE')} className="btn btn-outline sm m-0">
                <span className="icon-Delete-bold " />
              </button>
            </CustomTooltip>
          </div>
          {checkArray(productActiveGroup) && (
            <table className="table common-custom-table mt-16 mb-16">
              <thead>
                <tr>
                  <th className="w-50px">
                    <div className="common-checkbox">
                      <NewCheckbox size="sm" id="allGroup" checked={isAllChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
                    </div>
                  </th>
                  <th className="w-300px">{t('FILTER.GROUPS')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {productActiveGroup?.map((ele, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="common-checkbox">
                          <NewCheckbox size="sm" id={`productGRP${index}`} checked={selectedIndex.includes(index)} onChange={(e) => handleCheck(e, index)} />
                        </div>
                      </td>
                      <td>{ele.label}</td>
                      <td className="text-right">
                        <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
                          <button type="button" onClick={() => handleDeleteGoup(index)} aria-label={t('COMMON_LABEL.DELETE')} className="btn p-0">
                            <span className="icon icon-delete f-20" />
                          </button>
                        </CustomTooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="common-model-footer">
          <button type="button" onClick={() => handleProductToGroup()} className="btn p-0">
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductGroupModal;
